import React, { useContext, useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { FaEdit } from "react-icons/fa";
import { RxCross2 } from "react-icons/rx";
import { ThemeContext } from "../../../context/ThemeContext";
import { Table, Pagination } from "rsuite";
import { SkipToken } from "@reduxjs/toolkit/dist/query";
import useTitle from "../../../hooks/useTitle";

import { useGetAcCompanyListQuery } from "../../../features/ac/acCompanyCreate";
import { useCreateAcCompanyMutation } from "../../../features/ac/acCompanyCreate";
import { useUpdateAcCompanyMutation } from "../../../features/ac/acCompanyCreate";

import { useGetUserListQuery } from "../../../features/ac/acUserRoleApi";
import { useUpdateUserRoleMutation } from "../../../features/ac/acUserRoleApi";

const { Column, HeaderCell, Cell } = Table;

function UserRole() {
  useTitle("User Role");
  const [show, setShow] = useState(false);
  const [createFormSelector, setCreateFormSelector] = useState(true);
  const [updateFormData, setUpdateFormData] = useState({});
  const [reseponseMessage, setResponseMessage] = useState();
  const theme = useContext(ThemeContext);

  // const { data: sensorList, isLoading } = useGetAllSensorListQuery();
  const { data: userList, isLoading } = useGetUserListQuery();
  // const [createAcCompany] = useCreateAcCompanyMutation();
  const [updateUserRole] = useUpdateUserRoleMutation();

  const [limit, setLimit] = React.useState(10);
  const [page, setPage] = React.useState(1);

  let defaultData = [];
  let data = [];

  if (!isLoading) {
    if (userList?.data) {
      defaultData = [...userList.data];
      defaultData = defaultData?.map((alertInfo) => {
        const data = new Date(alertInfo.updated_at);
        const formattedDate = data.toLocaleString();
        return {
          ...alertInfo,
          updated_at: formattedDate,
        };
      });
    }

    data = defaultData?.filter((v, i) => {
      const start = limit * (page - 1);
      const end = start + limit;
      return i >= start && i < end;
    });
  }

  const handleChangeLimit = (dataKey) => {
    setPage(1);
    setLimit(dataKey);
  };
  const handleEdit = (id) => {
    let formData = defaultData.find((object) => object.id == id) || {};
    setUpdateFormData(formData);
    // console.log(formData);
  };
  const handleModalOutsideClick = () => {
    setShow(false);
    setResponseMessage("");
  };
  const dataChangeHandler = (e) => {
    setResponseMessage("");
    setUpdateFormData((previousValue) => ({
      ...previousValue,
      [e.target.name]: e.target.value,
    }));
  };
  //for data table

  const formSubmitHandler = (e) => {
    e.preventDefault();
    if (createFormSelector) {
      // createAcCompany(updateFormData)
      //   .unwrap()
      //   .then((payload) => setResponseMessage(payload?.message))
      //   .catch((error) => setResponseMessage(error?.status));
    } else {
      updateUserRole(updateFormData)
        .unwrap()
        .then((payload) => setResponseMessage(payload?.message))
        .catch((error) => setResponseMessage(error?.status));
    }
  };
  const handleClose = () => {
    setShow(false);
  };
  return (
    <div className={`row row-sm ${theme} `}>
      <div
        className="theme-text"
        style={{ fontSize: "20px", fontWeight: "bold", paddingBottom: "1rem" }}
      >
        User Role
      </div>
      {/* <div style={{ textAlign: "right", marginBottom: "1rem" }}>
        <button
          type="submit"
          className="btn btn-primary btn-md "
          onClick={() => {
            setShow(true);
            setCreateFormSelector(true);
            setUpdateFormData({});
          }}
        >
          Create Company
        </button> 
      </div> */}
      <Modal
        show={show}
        onHide={handleClose}
        classname={`${theme} `}
        centered
        onExited={handleModalOutsideClick}
      >
        <div className={`${theme}`}>
          <Modal.Header
            className="theme-background theme-text"
            style={{ borderRadius: "0px" }}
          >
            <Modal.Title>
              {createFormSelector ? "Add Role" : "Update Role"}
            </Modal.Title>
            <div style={{ color: "green" }}>{reseponseMessage}</div>
            <RxCross2 onClick={handleModalOutsideClick} />
          </Modal.Header>
          <Modal.Body className="theme-background theme-text">
            {" "}
            <div className="col-lg-12 col-xl-12 col-md-12 col-sm-12 zero-padding">
              <div>
                <div>
                  <form onSubmit={formSubmitHandler}>
                    <div className="form-group">
                      <label for="sensorName">
                        User Name <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Company Name"
                        // value={name}
                        defaultValue={updateFormData?.name || ""}
                        name="name"
                        onChange={(e) => {
                          // setSensorName(e.target.value);
                          dataChangeHandler(e);
                        }}
                        readOnly
                        required
                      />
                    </div>
                    <div class="form-group">
                      <label class="form-label" for="premises no">
                        Select Role <span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        required
                        name="role"
                        class="form-control form-select"
                        onChange={(e) => {
                          dataChangeHandler(e);
                        }}
                        defaultValue={updateFormData?.role || ""}
                      >
                        <option label="Choose one"></option>
                        <option value="admin">Admin</option>
                        <option value="user">User</option>
                        <option value="editor">Editor</option>
                      </select>
                    </div>

                    <div style={{ textAlign: "center" }}>
                      <Button type="submit">Submit</Button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </Modal.Body>
        </div>
      </Modal>
      <div>
        <div className="table-responsive theme-background theme-text">
          <Table
            height={500}
            data={data || []}
            loading={defaultData.length > 0 ? false : true}
          >
            <Column
              width={50}
              align="center"
              className={`theme-text theme-table-background`}
            >
              <HeaderCell style={{ color: "#6C88AF" }}>Id.</HeaderCell>
              <Cell dataKey="id" />
            </Column>
            <Column
              width={200}
              align="center"
              flexGrow={1}
              className={`theme-text theme-table-background`}
              fullText
            >
              <HeaderCell style={{ color: "#6C88AF" }}>User Name</HeaderCell>
              <Cell dataKey="name" />
            </Column>
            <Column
              width={200}
              align="center"
              flexGrow={1}
              className={`theme-text theme-table-background`}
              fullText
            >
              <HeaderCell style={{ color: "#6C88AF" }}>Email</HeaderCell>
              <Cell dataKey="email" />
            </Column>
            <Column
              width={200}
              align="center"
              flexGrow={1}
              className={`theme-text theme-table-background`}
              fullText
            >
              <HeaderCell style={{ color: "#6C88AF" }}>Role</HeaderCell>
              <Cell dataKey="role" />
            </Column>

            <Column
              width={200}
              align="center"
              flexGrow={1}
              className={`theme-text theme-table-background`}
            >
              <HeaderCell style={{ color: "#6C88AF" }}>Last Updated</HeaderCell>
              <Cell dataKey="updated_at" />
            </Column>
            <Column
              width={200}
              align="center"
              flexGrow={1}
              className={`theme-text theme-table-background`}
            >
              <HeaderCell style={{ color: "#6C88AF" }}>Edit</HeaderCell>
              <Cell>
                {(rowData) => (
                  <div
                    icon="edit"
                    onClick={() => {
                      setShow(true);
                      setCreateFormSelector(false);
                      handleEdit(rowData.id);
                    }}
                  >
                    <FaEdit />
                  </div>
                )}
              </Cell>
            </Column>
          </Table>
          <div style={{ padding: 20 }}>
            <Pagination
              prev
              next
              first
              last
              ellipsis
              boundaryLinks
              maxButtons={5}
              size="lg"
              layout={["total", "-", "limit", "|", "pager", "skip"]}
              total={defaultData.length}
              limitOptions={[10, 30, 50]}
              limit={limit}
              activePage={page}
              onChangePage={setPage}
              onChangeLimit={handleChangeLimit}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserRole;
